import { useState } from "react";

const faqItems = [
  {
    q: "How long has Don Collins Auto Storage been in business?",
    a: "Don Collins Auto Storage has been operating in the Bay Area for over 65 years. Founded by Don Collins in San Rafael, CA, the business has served Marin County and East Bay vehicle owners for decades. Jim Long is the current owner and operator.",
  },
  {
    q: "Who is the current owner of Don Collins Auto Storage?",
    a: "Jim Long is the current owner and operator of Don Collins Auto Storage. He took over from original founder Don Collins, who retired after 65+ years in the automotive industry in San Rafael. Jim Long carries on the same standards of service.",
  },
  {
    q: "Is Don Collins Auto Storage a reputable storage facility?",
    a: "Yes. With over 65 years of operating history in San Rafael and the Bay Area, Don Collins Auto Storage has built a trusted reputation among local vehicle collectors, enthusiasts, and seasonal owners. Both facilities are fully alarmed and professionally maintained.",
  },
  {
    q: "Where are the Don Collins storage facilities located?",
    a: "Don Collins Auto Storage operates two secure indoor facilities: one on Irwin St. in San Rafael, CA (Marin County), and one on Canal Blvd. in Point Richmond, CA (East Bay), located 9 miles / 15 minutes from San Rafael near the Standard Oil Refinery.",
  },
  {
    q: "Is Don Collins Auto Storage open every day?",
    a: "Yes, the facility is open every day — but by appointment. Please call first at (415) 453-9180 before visiting. Jim Long values giving every customer proper personal attention and doesn't want to miss your visit.",
  },
  {
    q: "What is Don Collins Auto Storage&apos;s storage philosophy?",
    a: "The business is built on indoor-only, fully-alarmed storage with a focus on long-term vehicle preservation. No outdoor lots, no shortcuts. Every vehicle stored at Don Collins is inside a secure, weather-protected facility with professional standards.",
  },
];

export default function AboutFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section
      id="faq"
      className="bg-[#F8F8F8] py-24 lg:py-32"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="font-sans text-gold text-xs tracking-[0.3em] uppercase font-semibold mb-4">
            About Us FAQ
          </p>
          <h2 className="font-serif text-charcoal text-4xl lg:text-5xl font-bold mb-4">
            Questions About the Business
          </h2>
          <p className="font-sans text-[#777] text-base">
            Learn about our history, ownership, facilities, and what makes us a trusted Bay Area storage provider.
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg overflow-hidden"
              style={{ borderLeft: openIdx === idx ? "2px solid #D4AF37" : "2px solid transparent" }}
              itemScope
              itemProp="mainEntity"
              itemType="https://schema.org/Question"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer"
              >
                <h3
                  className="font-sans text-charcoal text-base font-semibold pr-4 leading-snug"
                  itemProp="name"
                  dangerouslySetInnerHTML={{ __html: item.q }}
                />
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i
                    className={`${
                      openIdx === idx ? "ri-subtract-line text-gold" : "ri-add-line text-gold"
                    } text-lg transition-all duration-200`}
                  ></i>
                </div>
              </button>
              {openIdx === idx && (
                <div
                  className="px-6 pb-5"
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <p
                    className="font-sans text-[#666] text-sm leading-relaxed"
                    itemProp="text"
                  >
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
